 import GongqiFormItem from './GongqiFormItem';
import {GroupCurrentRecordChangedStore,RecordsCmpStore,RecordsRestoreCmpStore,RecordRefreshStore,RecordAutoSaveCmpStore, RecordDataMethodFieldChangedStore} from '../stores/RecordsStore';
import {FocusSetStore,HoldFousStore} from '../stores/FocusStore';
import FocusActions from '../actions/FocusActions';
import {CommandMapEditorsStore,CallComponentFuncStore} from '../stores/CommandStore';
import {CmdWriteControlStore,DsAllowEditStore,CmdUpdateControlAllowEditStore,BindStyleStore,CmdUpdateControlLabelStore,CmdUpdateControlPropertyStore} from '../stores/CmdTypeStore';
import {LookupReturnMutiEditorStore} from '../stores/LookupStores';
import FormItemUtil from '../utils/FormItemUtil';
import StringUtil from '../utils/StringUtil';
import CommandResolver from '../utils/CommandResolver';
import ControlPropertyConst from './ControlPropertyConst';
import CommandTask from '../forms/sys/remote/CommandTask';
import Cmd from '../forms/sys/remote/Cmd';
import UtilActions from '../actions/UtilActions';

export default class FormItemEditor extends GongqiFormItem{
	
	constructor(props) {
		super(props);
		this.record = "";
		this.origRecord = null;
		this.currentDataFieldChanged = false;
		this.holdFocus = this.props.holdFocus;
		this.registerStores();
		//构造方法时 因为还没有记录 所以应该都不满足bind的style 所以初始state不用设置
		//只在currentRecordChanged时设置即可
		this.state={
			displayLength:this.props.displayLength,
			displayHeight:this.props.displayHeight,
			notNull:this.props.notNull,
			visible:this.props.controlVisible,
			hideInVisible:this.props.hideInVisible,
			allowEdit:this.props.underQueryGroup?false:true,
			underQueryGroup:this.props.underQueryGroup,
			label:this.props.label
		}
	}

	componentWillUnmount()
	{
		this.distroyCommonStores();
	}

	distroyCommonStores()
	{
		if(!this.props.forLookup)
		{
			if(typeof(this.unsubscribeRecordsCmpStore) == "function")
				this.unsubscribeCmdUpdateControlAllowEditStore();
			if(typeof(this.unsubscribeCmdDsAllowEditStore) == "function")
				this.unsubscribeCmdDsAllowEditStore();
			if(typeof(this.unsubscribeLookupReturnMutiEditorStore) == "function")
				this.unsubscribeLookupReturnMutiEditorStore();
		}

		if(typeof(this.unsubscribeGroupCurrentRecordChangedStore) == "function")
			this.unsubscribeGroupCurrentRecordChangedStore();
		if(typeof(this.unsubscribeFocusSetStore) == "function")
			this.unsubscribeFocusSetStore();
		if(typeof(this.unsubscribeCommandMapEditorsStore) == "function")
			this.unsubscribeCommandMapEditorsStore();
		if(typeof(this.unsubscribecallComponentFuncStore) == "function")
			this.unsubscribecallComponentFuncStore();
		if(typeof(this.unsubscribeCmdWriteControlStore) == "function")
			this.unsubscribeCmdWriteControlStore();
		if(typeof(this.unsubscribeCmdUpdateControlLabelStore) == "function")
			this.unsubscribeCmdUpdateControlLabelStore();
		if(typeof(this.unsubscribeCmdUpdateControlPropertyStore) == "function")
			this.unsubscribeCmdUpdateControlPropertyStore();
		if(typeof(this.unsubscribeBindStyleStore) == "function")
			this.unsubscribeBindStyleStore();
		if(typeof(this.unsubscribeRecordsCmpStore) == "function")
			this.unsubscribeRecordsCmpStore();
		if(typeof(this.unsubcribeRecordsRestoreCmpStore) == "function")
			this.unsubcribeRecordsRestoreCmpStore();
		if(typeof(this.unsubscribeRecordAutoSaveCmpStore) == "function")
			this.unsubscribeRecordAutoSaveCmpStore();
		if(typeof(this.unsubscribeRecordRefreshStore) == "function")
			this.unsubscribeRecordRefreshStore();
		if(typeof(this.unsubscribeHoldFocusStore) == "function")
			this.unsubscribeHoldFocusStore();
	
	}


	registerStores()
	{
		if(!this.props.forLookup)
		{
			this.unsubscribeCmdUpdateControlAllowEditStore = CmdUpdateControlAllowEditStore.listen(this.onCmdUpdateControlAllowEditStore.bind(this));	
			this.unsubscribeCmdDsAllowEditStore = DsAllowEditStore.listen(this.onDsAllowEdit.bind(this));
			this.unsubscribeLookupReturnMutiEditorStore = LookupReturnMutiEditorStore.listen(this.onMutiEditorReturn.bind(this));
		}
		this.unsubscribeGroupCurrentRecordChangedStore = GroupCurrentRecordChangedStore.listen(this.onCurrentRecordChanged.bind(this));
		this.unsubscribeFocusSetStore = FocusSetStore.listen(this.onFocusSet.bind(this));
		this.unsubscribeCommandMapEditorsStore = CommandMapEditorsStore.listen(this.onMapEditorsHandler.bind(this));
		this.unsubscribecallComponentFuncStore = CallComponentFuncStore.listen(this.onCallFuncHandler.bind(this));
		this.unsubscribeCmdWriteControlStore = CmdWriteControlStore.listen(this.onCmdWriteControlStore.bind(this));
		
		this.unsubscribeCmdUpdateControlLabelStore = CmdUpdateControlLabelStore.listen(this.onCmdUpdateControlLabel.bind(this));
		this.unsubscribeCmdUpdateControlPropertyStore = CmdUpdateControlPropertyStore.listen(this.onCmdUpdateControlProperty.bind(this));
		
		this.unsubscribeBindStyleStore = BindStyleStore.listen(this.onBindStyle.bind(this));
		this.unsubscribeHoldFocusStore = HoldFousStore.listen(this.onHoldFocus.bind(this));
		let dataMethod = this.props.control.getProperty_DataMethod();
		if(dataMethod && dataMethod.charAt(0) == "#")
		{
			this.unsubscribeRecordsCmpStore = RecordsCmpStore.listen(this.onExecuteRecordRefresh.bind(this));
			this.unsubcribeRecordsRestoreCmpStore = RecordsRestoreCmpStore.listen(this.onExecuteRecordRefresh.bind(this));
			this.unsubscribeRecordAutoSaveCmpStore = RecordAutoSaveCmpStore.listen(this.onExecuteRecordRefresh.bind(this));
			this.unsubscribeRecordRefreshStore = RecordRefreshStore.listen(this.onExecuteRecordRefresh.bind(this));
			this.unsubscribeRecordDataMethodFieldChangedStore = RecordDataMethodFieldChangedStore.listen(this.onExecuteRecordRefresh.bind(this));
		}
	}

	onExecuteRecordRefresh()
	{
		let dataMethod = this.props.control.getProperty_DataMethod();
		let opr = dataMethod.substring(1,dataMethod.indexOf("("));
		let content = dataMethod.substring(dataMethod.indexOf("(") + 1,dataMethod.indexOf(")"));
		var mainSource,field;
		if(content.indexOf(".")!=-1)
		{
			mainSource = content.split(".")[0];
			field = content.substr(content.indexOf(".")+1);
		}
		else
		{
			mainSource = content;
			field = "";
		}

		if(!field)//count
		{
			let formModule = this.props.control.module;
			let group = formModule.formDataSources.groups[mainSource];
			let recordsNum = group.records.length;
			this.setDisplayFieldText(recordsNum);
		}
		else//sum
		{
			let sum = 0;
			let formModule = this.props.control.module;
			let group = formModule.formDataSources.groups[mainSource];
			if(group.records)
			{
				for(let i = 0;i<group.records.length;i++)
				{
					let _record = group.records[i];
					let _value = _record[mainSource+"."+StringUtil.convertToFirstLowerCase(field)];
					if(typeof(_value) != "number")
						_value = parseFloat(_value)
					sum+=_value;
				}
			}
			this.setDisplayFieldText(sum);
		}
	}

	onBindStyle(formId,name)
	{
		if(this.props.formId == formId && this.props.xml.name == name)
		{
			this.updateRecordCondition()
		}
	}

	onHoldFocus(formId,itemId)
	{
		if(this.props.formId == formId && this.props.xml.id == itemId)
		{
			$(this.inputField).focus();
			$(this.inputField).select();
			this.holdFocus = true;
		}
		else
		{
			this.holdFocus = false;
		}
	}

	onCallFuncHandler(entityId,innerId,funcName,funcArg,result)
	{
		if(this.props.formId == entityId && this.props.xml.id == innerId)
		{
			if(typeof(this[funcName]) == 'function')
			{
				let ret = this[funcName].apply(this,funcArg);
				if(result)
					result.ret = ret;
			}
		}
	}

	onCmdWriteControlStore(arg,moduleInstanceId,triggerModify)
	{
		if(arg && arg.hasOwnProperty(this.props.xml.name) && this.props.moduleInstanceId == moduleInstanceId)
		{
			var value = arg[this.props.xml.name];
			this.setDisplayFieldText(value,triggerModify);
			if(this.props.underQueryGroup)
			{
				this.setQueryGroupEnable(true);
			}
		}
	}

	

	onCmdUpdateControlAllowEditStore(name,_allowEdit)
	{
		//alert(name+":"+_allowEdit);
		if(name!=this.props.xml.name)
			return;
		if(this.props.control)
		{
			/*var _allowEdit = true;
			if(!this.record)
			{
				_allowEdit = false;
			}
			else
			{
				_allowEdit = this.props.control.getProperty_AllowEdit_Final();
			}*/
			let finalValue;
			if(this.props.control.group && !this.props.control.group.currentRecord)
				finalValue = false;
			else
				finalValue = this.props.control.getProperty_AllowEdit_Final();

			this.doSetEnable(finalValue);	
		}
		
	}

	componentDidUpdate(prevProps, prevState, snapshot)
	{
		if(this.state.label != prevState.label)
		{
			let control = this.props.control;
			let parentControl = control.parentControl;
			if(parentControl.classAlias == "FormItemFieldGroupControl")
			{
				UtilActions.updateControlLabel({controlId:parentControl.xml.id});
			}
			
		}
	}

	onCmdUpdateControlLabel(name,_label,moduleInstanceId)
	{
		if(name != this.props.xml.name || this.props.moduleInstanceId != moduleInstanceId)
			return;
		this.setState({label:_label});
	}

	onCmdUpdateControlProperty(name,property,value,moduleInstanceId)
	{
		if(name != this.props.xml.name || this.props.moduleInstanceId != moduleInstanceId)
			return;
		if(property == ControlPropertyConst.DISPLAYLENGTH)
		{	this.setState({displayLength:value});return true;}
		else if(property == ControlPropertyConst.NOTNULL)
		{	this.setState({notNull:value});return true;}
		return false;
	}

	onDsAllowEdit(groupAlias)
	{
		if(this.props.groupAlias == groupAlias)
		{
			var _allowEdit = true;
			if(!this.record)
			{
				_allowEdit = false;
			}
			else
			{
				_allowEdit = this.props.control.getProperty_AllowEdit_Final();
			}
			this.doSetEnable(_allowEdit);	
		}
	}

	onMapEditorsHandler(selector,mapEditorValues,moduleInstanceId)
	{
		if((this.props.groupAlias == "" || !this.props.groupAlias) && this.props.moduleInstanceId == moduleInstanceId)
		{
			if(selector!="all" && this.props.xml.name != selector)
				return;
			if(this.props.underQueryGroup && !this.getInQueryGroupNow())
				return;
			if(this.props.underQueryGroup){
				if(this.record=='-只查空值-'){
					mapEditorValues[this.props.xml.name] = "";
				}else{
					mapEditorValues[this.props.xml.name] = 
					(!this.record||this.record == "")?this.props.defaultValueForCMD:this.record;	
				}
			}else{

				mapEditorValues[this.props.xml.name] = 
					(!this.record||this.record == "")?this.props.defaultValueForCMD:this.record;	
			}
		}
		
	}

	onFocusSet(formId,itemId,pre,init)
	{
		if(this.props.formId == formId && this.props.xml.id == itemId)
		{
			let that = this;
			setTimeout(function(){
				$(that.inputField).focus();
				$(that.inputField).select();
			},200);
		}
	}

	onKeyDownHandler(e)
	{
		
		let keyboardArg = this.props.control?this.props.control.propertyKeyDownEvent:null;
		if(keyboardArg)
		{
			for(let i = 0;i<keyboardArg.keyCodeArgs.length;i++)
			{
				let keyCodeArg = keyboardArg.keyCodeArgs[i];
				if(keyCodeArg.ctrlKey==e.ctrlKey && keyCodeArg.shiftKey==e.shiftKey && (keyCodeArg.keyCode==e.keyCode || keyCodeArg.keyCode == e.charCode))
				{
					e.preventDefault();
					let callBackArg = {remoteClass:"gongqi.erp.gotmodel.form.remote.KeyCodeResult"};
					callBackArg.ctrlKey = e.ctrlKey;
					callBackArg.shiftKey = e.shiftKey;
					callBackArg.keyCode = e.keyCode;
					setTimeout(this.doKeyBoardServer.bind(this),500,callBackArg);
					return true;
				}	
			}
		}
		//alert(e.keyCode);
		if(9===e.keyCode || 13===e.keyCode)
		{
			e.preventDefault();
			FocusActions.focusChange(this.props.xml,e.shiftKey);
			return true;
		}

		return false;
	}

	doKeyBoardServer(callBackArg)
	{		
		let arg = {};
		arg["methodName"] = "keyDownEvent_" + this.props.xml.name;
		
		callBackArg.editorValue = this.getDisplayFieldText(); 
		arg["methodArg"] = callBackArg;
			
		var commandTask = new CommandTask();
		commandTask.cmd = Cmd.FormCmd;
		commandTask.arg = arg;
		CommandResolver.formCmd(commandTask,this.props.control.module);
	}

	onCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId)
	{
		if(this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId)
		{
			this.record = currentRecord;
			if(this.props.dataField)
			{
				this.origRecord = Object.assign({},currentRecord);
			}
			this.updateRecordCondition();
		}
	}

	getEditorStyles()
	{
		let menuItemId = this.props.menuItemId;
		let formId = this.props.formId;
		let innerId = this.props.xml.id;
		return FormItemUtil.getControlStyles(menuItemId,formId,innerId);
	}

	updateRecordCondition()
	{
		if(!this.props.control)
			return;
		let _style = {color:-1,backgroundColor:-1,fontSize:-1,fontFamily:null,fontWeight:null};
		let group = this.props.control.group;
		let colStyles = this.getEditorStyles();
		if(colStyles)
		{
			for(let i = 0;i<colStyles.length;i++)
			{
				let colStyle = colStyles[i];
				let bool = false;
				if(group)
					bool = group.analysisConditionSingleRecord1(this.record,colStyle.recordCondition);
				else
					bool = this.props.control.analysisConditionSingleValue(this.record,colStyle.valueCondition);
				if(bool)
				{
					if(colStyle.color != -1) _style.color = "#"+colStyle.color.toString(16); else _style.color = -1;
					if(colStyle.backgroundColor != -1) _style.backgroundColor = "#"+colStyle.backgroundColor.toString(16);else _style.backgroundColor = -1;
					if(colStyle.fontSize != -1)_style.fontSize = colStyle.fontSize;else _style.fontSize = -1;
					if(colStyle.fontFamily != null)_style.fontFamily = colStyle.fontFamily;else _style.fontFamily = null;
					if(colStyle.fontWeight != null)_style.fontWeight = colStyle.fontWeight;else _style.fontWeight = null;
				}
			}
			this.setState(_style);
		}
	}

	setDisplayNoResolve(value)
	{
		this.setDisplay(value);
	}

	//设置显示的值 对于ForDataGrid无用
	setDisplay(_value)
	{
		
	}

	updateModifiedTag()
	{
		if(this.props.groupAlias == "")
			return;
		if(this.record == null || this.record == undefined)
			return;
		if(this.origRecord == null || this.origRecord == undefined)
			return;
		let newValue = $(this.inputField).val();
		var origValue = this.origRecord[this.props.dataField];
		if(origValue != newValue)
		{
			//alert(origValue + "  " + newValue);
			this.currentDataFieldChanged = true;
			$(this.modifiedTag).css("display","block");
		}
		else
		{
			this.currentDataFieldChanged = false;
			$(this.modifiedTag).css("display","none");
		}
	}

	inQueryGroup = false;
	getInQueryGroupNow()
	{
		return this.inQueryGroup;
	}
	labelClickHandler()
	{
		if(!this.state.underQueryGroup)
			return;
		// this.setQueryGroupEnable(!this.inQueryGroup);
	}
	
	//QueryGroup中的编辑框无法通过GOT record 权限等控制可编辑性
	setQueryGroupEnable(_inQueryGroup = false)
	{
		this.inQueryGroup = _inQueryGroup;
		if(this.inQueryGroup)
		{
			//$(this.componentLabel).css("color","#000000");
			this.doSetEnable(true);
			$(this.inputField).focus();
			$(this.inputField).select();
		}
		else
		{
			//$(this.componentLabel).css("color","#CFCFCF");
			this.doSetEnable(false);
		}
	}
	
	doSetEnable(enable)
	{

	}

	componentDidMount()
	{
		/*if(this.props.underQueryGroup)
		{
			$(this.componentLabel).click(this.labelClickHandler.bind(this));
			$(this.componentLabel).css("cursor","pointer");
			$(this.componentLabel).css("color","#CFCFCF");
		}*/

				//TODO_YL 改成 不触发modify 方法  会有什么问题？
		if(this.props.initEditorValue)
		{
			this.setDisplayFieldText(this.props.initEditorValue,false);
		}

		if(this.props.customStyle && this.props.customStyle.hasOwnProperty("visibility"))
			$("#Editor"+this.props.xml.id).css("display","none");
	}

	getDisplayFieldText()
	{
		return $(this.inputField).val();
	}
	
	getFormAutoQueryValue()
	{
		var _text = this.getDisplayFieldText();
		_text = this.props.control.getQueryFilteredVaue(_text);
		return _text;
	}

	setFinalValue()
	{

	}

	//TODO DataMethod等特殊情况会调用此方法 若非特殊情况调用 会重复setDisplay
	setDisplayFieldText(value,triggerModify = true)
	{
		//$(this.inputField).val(value);
		//_displayField["text"] = value;
		this.setFinalValue(value,triggerModify);
		this.setDisplay();
		var curFocus = document.activeElement;
		if($(this.inputField).is(curFocus) ||
			$(this.inputField).find(curFocus).length)
		{
			$(this.inputField).focus();
			$(this.inputField).select();
		}
	}

	setDisplayFieldDefText(value,triggerModify = true){
		this.setFinalValue(value,triggerModify);
	}

	onMutiEditorReturn(editorName,value)
	{
		if(this.props.xml.name == editorName)
		{
			this.setDisplayFieldText(value,false);
		}
	}

	doSetModifiedTagNone()
	{
		$(this.modifiedTag).css("display","none");
	}

	doSetModifiedTagHas()
	{
		$(this.modifiedTag).css("display","block");
	}

	render()
	{
		
	}
}


// WEBPACK FOOTER //
// ./src/formItem/FormItemEditor.js